import type { ReactNode } from "react";
import { Reveal } from "./Reveal";

export function Eyebrow({ children }: { children: ReactNode }) {
  return (
    <span className="text-xs font-semibold uppercase tracking-wide text-fg-subtle">{children}</span>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  as: TitleTag = "h2",
}: {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  align?: "center" | "left";
  as?: "h1" | "h2";
}) {
  const alignment = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  // Wird die Überschrift als H1 gerendert, steht sie im ersten Bildschirm und
  // ist der LCP-Kandidat – dann ohne Einblend-Verzögerung ausgeben.
  const isHero = TitleTag === "h1";
  return (
    <div className={`flex max-w-3xl flex-col gap-5 ${alignment}`}>
      {eyebrow && (
        <Reveal immediate={isHero}>
          <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
      )}
      <Reveal immediate={isHero} delay={80}>
        <TitleTag className="text-balance text-3xl font-bold tracking-tight text-fg sm:text-4xl md:text-[2.75rem] md:leading-[1.1]">
          {title}
        </TitleTag>
      </Reveal>
      {subtitle && (
        <Reveal immediate={isHero} delay={160}>
          <p className="text-pretty text-base leading-relaxed text-fg-muted sm:text-lg">{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}
